module.exports = __webpack_public_path__ + "images/622a90d81fbbdc011adccc4a464dd5a2.svg";